import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import { getPCTransactionById } from '../../axios/ProjectCostTransactionAxios';
import { getInquiry } from '../../axios/Inquiry';
import { Link } from 'react-router-dom';

const InquiryView = () => {
  const { id } = useParams(); // pct_id dari URL
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Inquiry', href: '/inquiry' },
    { label: 'View Inquiry' },
  ];

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [groupNameMap, setGroupNameMap] = useState({});

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const [projectRes, inquiryRes] = await Promise.all([
          getPCTransactionById(id),
          getInquiry(),
        ]);

        setProject(projectRes.data);

        // 🔹 buat map groupId -> name3
        const map = {};
        inquiryRes.data.forEach((item) => {
          if (!map[item.kode_singkat]) {
            map[item.kode_singkat] = item.name3;
          }
        });

        setGroupNameMap(map);
      } catch (error) {
        console.error(error);
        alert('Gagal mengambil data inquiry');
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [id]);

  if (loading) {
    return (
      <div>
        <Breadcrumb items={breadcrumbItems} />
        <div className="text-center my-5">
          <div className="spinner-border" role="status" />
        </div>
      </div>
    );
  }

  const groupedByGroupId = project.journals.reduce((acc, item) => {
    if (!acc[item.groupId]) {
      acc[item.groupId] = {
        groupId: item.groupId,
        name3: groupNameMap[item.groupId] || '-',
        total: 0,
      };
    }

    acc[item.groupId].total += Number(item.total || 0);
    return acc;
  }, {});

  const groupedRows = Object.values(groupedByGroupId);

  return (
    <div className="container-fluid">
      <Breadcrumb items={breadcrumbItems} />

      {/* ================= PROJECT INFO ================= */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0 fw-bold">{project.project}</h6>
          <span className="badge bg-success fs-6">
            Total Project : {Number(project.total_cost).toLocaleString('id-ID')}
          </span>
        </div>

        <div className="card-body">
          <div className="row fs-15">
            <div className="col-md-6">
              <Info label="Project" value={project.project} />
              <Info label="Location" value={project.location} />
              <Info label="PO No.1" value={project.poNo1} />
            </div>
            <div className="col-md-6">
              <Info label="Year" value={project.year} />
              <Info label="PO No.2" value={project.poNo2} />
            </div>
          </div>
        </div>
      </div>

      {/* ================= JOURNAL TABLE ================= */}
      <div className="card shadow-sm">
        <div className="card-header fw-bold">Cost Summary</div>

        <div className="card-body pt-0">
          <div className="table-responsive">
            <table className="table table-bordered table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>Group</th>
                  <th>Cost Name</th>
                  <th className="text-end">Total Amount</th>
                </tr>
              </thead>

              <tbody>
                {groupedRows.map((row) => (
                  <tr key={row.groupId}>
                    <td>{row.groupId}</td>
                    <td>{row.name3}</td>
                    <td className="text-end">
                      {row.total.toLocaleString('id-ID')}
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot className="table-light">
                <tr>
                  <th className="text-end"></th>
                  <th className="text-end">Grand Total</th>
                  <th className="text-end">
                    {Number(project.total_cost).toLocaleString('id-ID')}
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <Link to="/inquiry" className="btn btn-warning">
          <i className="bi bi-arrow-left-circle me-1"></i>
          Back
        </Link>
      </div>
    </div>
  );
};

/* ===== Reusable Info Row ===== */
const Info = ({ label, value }) => (
  <div className="row mb-1">
    <div className="col-4 text-nowrap">{label}</div>
    <div className="col-8">: {value || '-'}</div>
  </div>
);

export default InquiryView;
